import sendLog from './sendLog';
import { getRequestBody, parseResponse, isIgnoreApi } from './parseResponse';
import AES from '@ali/aes-tracker';
import { isPromise } from '../promise';
/**
 * 从请求头对象Header实例中获取请求头
 * @method getRequestHeader
 * @param {Header} header 
 * @returns 
 */

function getRequestHeader(header) {
  if (window.Headers && header instanceof Headers) {
    var r = {};
    header.forEach(function (v, k) {
      r[k] = v;
    });
    return r;
  }
}
/**
 * 根据Response对象实例获取响应体内容，返回JSON或者字符串
 * @method getResponseBody
 * @param {Object} response 
 * @param {Object} request 
 * @returns {String|Object|Promise}
 */


function getResponseBody(response, request) {
  if (request.originResponse) return response; //TODO：这个是解决什么问题？

  if (request.method === 'jsonp') return response.text();
  var responseType = response.headers && response.headers.get ? response.headers.get('content-type') : null; // application/json

  if (!responseType || responseType.toLowerCase().indexOf('json') !== -1 || responseType.toLowerCase().indexOf('text') !== -1) {
    return response.text();
  } else {
    // return response.blob();
    return "[".concat(responseType, "]");
  }
}

function hookFetch() {
  if (typeof window.fetch !== 'function') return;
  if (window.fetch && window.fetch.polyfill) return; // 对于polyfill的fetch，不进行监听

  var _fetch = window.fetch;

  window.fetch = function (arg0) {
    var setting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = AES.getConfig('plugin_api') || {}; // method: 'HEAD' 或 mode: 'no-cors' 的请求不监听

    if (setting.method === 'HEAD' || setting.mode === 'no-cors') {
      return _fetch.apply(window, arguments);
    } // 请求的 url
    // 请求参数可能是URL String、URL对象、Request对象


    var original_url = typeof arg0 === 'object' ? arg0.url || arg0.href : arg0; // 跳过部分接口

    if (isIgnoreApi(original_url)) {
      return _fetch.apply(window, arguments);
    }

    var original_url_s = original_url.split('?');
    var url = original_url_s[0];
    var params = original_url_s[1]; // 如果没有设置settingg.method，fetch默认以GET方式发送请求，所以这里设置默认值为GET
    // Request：argo.method，其它场景：setting.method

    var method = setting.method || arg0.method || 'GET';
    var body, headers;

    try {
      headers = getRequestHeader(setting.headers || arg0.headers);
    } catch (ex) {}

    try {
      body = getRequestBody(setting.body || arg0, method); // 当body在Request对象中时

      if (isPromise(body)) {
        body.then(function (res) {
          body = res;
        });
      }
    } catch (ex) {}

    var begin = new Date().getTime();
    return _fetch.apply(window, arguments).then(function (origin) {
      try {
        // 判断是否原始的Response对象，有可能别人已经改写了，不能保证返回的origin是什么
        if (Object.prototype.toString.call(origin) !== '[object Response]') return origin;
        var duration = new Date().getTime() - begin; //polyfill未必有clone方法

        var res = origin.clone ? origin.clone() : origin;
        var status = res.status; // 获取鹰眼ID，不存在时get方法返回null，没有安全性报错

        var eagleeId;

        if (res.headers.has('eagleeye-traceid')) {
          eagleeId = res.headers.get('eagleeye-traceid');
        } else if (res.headers.has('x-eagleeye-id')) {
          eagleeId = res.headers.get('x-eagleeye-id');
        }

        var send = function send(response) {
          res = parseResponse(response, status, {
            type: 'fetch',
            params: params,
            url: url
          });

          if (res.success === false || !config.disable_send_on_success) {
            sendLog({
              url: url,
              method: method,
              success: res.success,
              msg: res.msg,
              status: status,
              code: res.code,
              duration: duration,
              traceId: eagleeId,
              params: params,
              headers: headers,
              body: body,
              response: response,
              rtype: 'fetch'
            });
          }
        };

        var resBody = getResponseBody(res, setting);

        if (isPromise(resBody)) {
          resBody.then(send);
        } else {
          send(resBody);
        }
      } catch (ex) {}

      return origin;
    }, function (err) {
      var duration = new Date().getTime() - begin;
      sendLog({
        url: url,
        method: method,
        success: false,
        msg: err.message,
        status: -1,
        duration: duration,
        params: params,
        body: body,
        headers: headers,
        rtype: 'fetch'
      });
      throw err;
    });
  };
}

;
export default hookFetch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/libs/hookFetch.js
// module id = null
// module chunks = 